import { useQuery } from "urql";
import type { SponsorProjectsQuery as SponsorProjectsQueryResult } from "../graphql/generated/graphql";
import { SponsorProjectsQuery } from "../graphql/sponsorProjects.graphql";

export type SponsorProject =
  SponsorProjectsQueryResult["sponsorProjects"][number];

export function useSponsorProjects(sponsorId: string | null, pause = false) {
  const [result, reexecute] = useQuery({
    query: SponsorProjectsQuery,
    variables: { sponsorId: sponsorId ?? "" },
    pause: !sponsorId || pause,
    // 管理画面でプロジェクトの詳細URLを登録したあと、作成フォームを開き直したときに反映させる
    requestPolicy: "cache-and-network",
  });

  return {
    sponsorProjects: result.data?.sponsorProjects ?? [],
    loading: result.fetching,
    error: result.error?.message ?? null,
    refetch: () => reexecute({ requestPolicy: "network-only" }),
  };
}
